/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, shape, array } from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import MetaTags from 'components/MetaTags/MetaTags';
import SectionBlocks from 'components/SectionBlocks/SectionBlocks';

import styles from './text-page.scss';

/**
 * This is the TextPage component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class TextPage extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    app: shape({
      locale: string.isRequired,
    }).isRequired,
    bootstrap: shape({
      pages: array.isRequired,
    }).isRequired,
  };

  /**
   * Render TextPage.
   *
   * @return {Object}
   */
  render() {
    const {
      app: { locale },
      bootstrap: { pages },
    } = this.props;

    // get current page URL without the locale.
    const pageSlug = window.location.pathname.replace(`/${locale}`, '');
    const currentPage = pages.find(page => page.aliases.includes(pageSlug));

    // if page not found redirect to english start page.
    if (!currentPage) {
      return <Redirect to="/" />;
    }

    const { meta_tags, hreflangs, sections } = currentPage;

    return (
      <article>
        <MetaTags {...meta_tags} />

        {hreflangs && (
          <Helmet defer={false}>
            {hreflangs.map(({ href, hreflang }) => (
              <link
                rel="alternate"
                href={href}
                hrefLang={hreflang}
                key={hreflang}
              />
            ))}
          </Helmet>
        )}

        <div className={styles.container}>
          <div className={styles.row}>
            <SectionBlocks sections={sections} />
          </div>
        </div>
      </article>
    );
  }
}

export default withRouter(
  connect(({ app, bootstrap }) => ({ app, bootstrap }))(TextPage)
);
